<template>
  <div class="my">
    <div class="my_bj">
      <div class="d-flex Profile">
        <img src="../../assets/img/tabar/examine.png" />
        <div style="margin: 10px">
          <p>
            {{ UserList.account }}
            <span style="color: #f6465d">{{ vip.name }}</span>
          </p>
          <p>UID:{{ UserList.userId }}</p>
        </div>
      </div>
      <div style="text-align: right" class="my_txt">
        <!-- 隐藏 -->
        <span @click="goLink('/member/cut')"> 切换 </span>
      </div>
    </div>

    <div class="property">
      <p>总资产（USDT）</p>
      <p class="d-flex" v-if="MoneyList != 0">
        <!-- <Tests :value="MoneyList" class="numsp"></Tests> -->
        <span style="font-size: 18px; margin-right: 10px">{{
          MoneyList.toFixed(3)
        }}</span>
        <span style="margin-top: 12px"> ≈ </span>
        <Tests :value="CNYmONEY" class="numss" style="margin-top: 15px"></Tests>
        <span style="margin-top: 15px">CNY</span>
      </p>
      <p class="d-flex" v-if="MoneyList == 0">
        <span>0</span>
        <span> ≈ </span>
        <span>0</span>
        <span style="margin-top: 2px">CNY</span>
      </p>
    </div>
 
    <div class="ground_list">
        <ul>
          <li
            v-for="item in TeamList"
            :key="item.id"
            @click="goLink(item.path)"
          >
          <div>
            <img :src="item.url" />
            <p class="fn-13">{{ item.txt }}</p>
          </div>
            <div>
                <van-icon name="arrow" size="18" color="#f89b19"/>
            </div>
          </li>
        </ul>
    </div>
    <Tabbar :active="3"></Tabbar>
  </div>
</template>
<script>
import Vue from "vue";
import { NoticeBar } from "vant";
Vue.use(NoticeBar);
import { mainApiData } from "@/request/api.js";
export default {
  data() {
    return {
      baseApi: "",

      Aeccter: {
        money: 75.8193,
        rate: 99.1234,
      },
      listHome: [
        {
          url: require("../../assets/img/page/QB-52.png"),
          txt: "钱包",
          id: 0,
          path: "/My/assets",
        },
        {
          url: require("../../assets/img/page/SD-52.png"),
          txt: "闪兑",
          id: 1,
          path: "/My/flashExchange",
        },
        {
          url: require("../../assets/img/page/RG-52.png"),
          txt: "认购",
          id: 2,
          path: "/subscription",
        },
        {
          url: require("../../assets/img/page/KJ-52.png"),
          txt: "矿机",
          id: 3,
        },
      ],
      SafeList: [
        {
          url: require("../../assets/img/page/mm.png"),
          txt: "登录密码",
          id: 0,
          path: "/system/update",
        },
        {
          url: require("../../assets/img/page/aq.png"),
          txt: "安全管理",
          id: 1,
          path: "/system/safety",
        },
        {
          url: require("../../assets/img/page/bf.png"),
          txt: "备份私钥",
          id: 2,
          path: "/My/key",
        },
        {
          url: require("../../assets/img/page/xt.png"),
          txt: "系统设置",
          id: 3,
          path: "/system",
        },
      ],
      TeamList: [
      {
          url: require("../../assets/img/page/dlmm-28.png"),
          txt: "登录密码",
          id: 0,
          path: "/system/update",
        },
        {
          url: require("../../assets/img/page/aqzx-28.png"),
          txt: "安全管理",
          id: 1,
          path: "/system/safety",
        },
        {
          url: require("../../assets/img/page/bfsy-28.png"),
          txt: "备份私钥",
          id: 2,
          path: "/My/key",
        },
        {
          url: require("../../assets/img/page/xtsz-28.png"),
          txt: "系统设置",
          id: 3,
          path: "/system",
        },
        {
          url: require("../../assets/img/page/wdtd-28.png"),
          txt: "我的团队",
          id: 4,
          path: "/My/group",
        },
        {
          url: require("../../assets/img/page/yqzc-28.png"),
          txt: "邀请注册",
          id: 5,
          path: "/My/invite",
        },
        {
          url: require("../../assets/img/page/wdsy-28.png"),
          txt: "我的收益",
          id: 6,
          path: "/My/income",
        },
      ],
      UserList: {},
      MoneyList: 0,
      CNYmONEY: 0,
      vip: "",
    };
  },
  created() {
    this.baseApi = process.env.VUE_APP_IMG;
    this.UserList = JSON.parse(sessionStorage.getItem("ms_user")).user;
    this.Init();
  },

  methods: {
    Init() {
      mainApiData.getUserEquivalent().then((res) => {
        if (res.data.code == 200) {
          this.MoneyList = res.data.data.USDT;
          this.CNYmONEY = res.data.data.CNY;
          console.log(this.MoneyList);
        }
      });
      mainApiData.getUserGrade().then((res) => {
        if (res.data.code == 200) {
          this.vip = res.data.data;
        }
      });
    },
    goLink(path, item) {
      if (path) {
        this.$router.push({
          path,
          query: {
            id: JSON.stringify(item),
          },
        });
      } else {
        // 暂未开放
        this.$toast(this.$t("orePond.a42"));
      }
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
// 引入全局的样式
@import "@/assets/scss/base.scss";
::v-deep .ground_list{
    // border: solid red 1px ;
    margin: 35px 10px 50px;
    padding: 20px 15px;
    border-radius: 10px;
    background: #292118;
    ul{
        li{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 15px;
            div:first-child{
                display: flex;
                align-items: center;
                img{
                    width: 28px;
                    height: 28px;
                    margin-right: 8px;
                }

            }
        }
    }
}
.my {
  .my_bj {
    // height: 173px;

    // background: url(../../assets/img/header/nj.png) no-repeat;
    // background-size: 100% 100%;
    display: flex;
    justify-content: space-between;

    .my_txt {
      margin-top: 35px;
      padding: 10px 15px;

      span {
        display: inline-block;
        padding: 5px 25px;
        border-radius: 12px;
        color: #fff;
        margin-top: 20px;
        box-shadow: 0 0 0 0.5px #f89b19; //实现0.5px四周线
      }
    }

    .Profile {
      margin: 50px 15px 0 15px;

      img {
        width: 52px;
        height: 52px;
      }

      div {
        p {
          &:nth-child(1) {
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            // line-height: 34px;
            /* identical to box height */

            text-align: center;

            /* 黄/主题 */

            color: #fff;
          }

          &:nth-child(2) {
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            // line-height: 20px;
            /* identical to box height */

            color: #9c9c9c;
          }
        }
      }
    }
  }

  .Acion {
    margin: 40px 0;

    ul {
      display: grid;
      justify-content: space-between;
      grid-template-columns: 25% 25% 25% 25%;
      text-align: center;

      li {
        p {
          padding: 10px 0;
          color: #fff;
        }
        img{
            width: 60px;
            height: 60px;
        }
      }

      // align-items: center;
    }
  }


  .property {
    margin: 15px 15px;
    padding: 0px 0 30px 0;
    border-radius: 10px;
    border: 0.5px solid #f89b19;
    // background: url(../../assets/img/page/hh.png) no-repeat;
    background: linear-gradient(91.24deg, #f89b19 0.21%, #a05118 65.96%, #a05118 126.44%);


    ::v-deep .number-grow {
      color: #fff !important;
      font-size: 15px;
    }

    ::v-deep .number-grows {
      color: #fff !important;
      font-size: 16px;
      margin-top: 3px;
      display: block;
    }

    p {
      &:nth-child(1) {
        padding: 20px 10px 0 10px;
        color: #fff !important;
        margin-bottom: 10px;
        font-size: 14px;
        // ::v-deep .numsp {

        //     font-size: 15px !important;
        //     border: 1px solid red;
        // }
      }

      span {
        color: #fff;
        font-size: 18px;
      }

      &:nth-child(2) {
        padding: 5px 10px 0 10px;
        .numsp {
          // font-size: 32px !important;
          // border: 1px solid red;
        }
      }

      .numsp {
        // font-size: 20px !important;
        // border: 1px solid red;
      }
    }
  }
}
</style>
